<template>
    <div class="h-100">
        <page-header
            @back="backToHome"
            :closeButton="true"
            :removeBackButton="true"
        />
        <b-container fluid class="max-width h-100 d-flex align-items-center justify-content-center">
            <div class="row justify-content-center mb-5 w-100">
                <div class="col-12 col-md-8">
                    <profile-wizard />
                </div>
            </div>
        </b-container>

        <page-progress
            :current="getCurrentStep"
            :max="getAllSteps"
        />
    </div>
</template>

<script>
    import PageHeader from "../organisms/PageHeader";
    import PageProgress from "../molecules/PageProgress";
    import ProfileWizard from "../organisms/profile-wizard/ProfileWizard"
    import {mapGetters} from "vuex";

    export default {
        name: "Profiling",
        components: {PageHeader, PageProgress, ProfileWizard},

        computed: {
            ...mapGetters({
                getCurrentStep: 'profile/getWizardCurrentStep',
                getAllSteps: 'profile/getWizardTotalSteps'
            })
        },
        methods: {
            backToHome() {
                this.$router.push({name: 'servicedashboard'})
            }
        }
    }
</script>
